import { ApplicationConfig, provideBrowserGlobalErrorListeners, provideZonelessChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';


import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { routes } from './app.routes';
// import { errorInterceptor } from '@core/interceptors/error/error-interceptor';
import { headerInterceptor } from '@core/interceptors/header/header-interceptor';
import { tokenInterceptor } from '@core/interceptors/token/token-interceptor';
import { provideGrapesJs } from '@ilq/grapesjs-angular';

// /errorInterceptor
export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZonelessChangeDetection(),
    provideGrapesJs({
      storageManager: false,
    }),

    provideRouter(routes),
    provideHttpClient(
      withInterceptors([headerInterceptor, tokenInterceptor])
    ),

  ],

};
